import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { RidgelinePlot } from "../components/RidgelinePlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.ridge_tool_name()}
        toolPath="/ridgeline-plot"
      />
      <SciHeader title={m.ridge_h1()} intro={m.ridge_intro()} />

      <RidgelinePlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.ridge_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.ridge_ex1(), m.ridge_ex2(), m.ridge_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.ridge_faq_q1(), a: m.ridge_faq_a1() },
          { q: m.ridge_faq_q2(), a: m.ridge_faq_a2() },
          { q: m.ridge_faq_q3(), a: m.ridge_faq_a3() },
          { q: m.ridge_faq_q4(), a: m.ridge_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
